import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import * as dotenv from "dotenv";
dotenv.config();
createApp(App).use(store).mount("#app");
